import { render, staticRenderFns } from "./VIPExchange.vue?vue&type=template&id=4289ae44&scoped=true&"
import script from "./VIPExchange.vue?vue&type=script&lang=js&"
export * from "./VIPExchange.vue?vue&type=script&lang=js&"
import style0 from "./VIPExchange.vue?vue&type=style&index=0&id=4289ae44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289ae44",
  null
  
)

export default component.exports